import React from "react";
import {
  FaFacebookF,
  FaInstagram,
  FaTwitter,
  FaLinkedinIn,
  FaYoutube,
  FaArrowRight,
  FaStethoscope,
  FaHeartbeat,
  FaTooth,
  FaEye,
  FaBrain,
  FaBone,
  FaBaby,
  FaUserMd,
  FaClinicMedical,
  FaPhoneAlt,
  FaEnvelope,
  FaMapMarkerAlt,
  FaShieldAlt,
  FaRegClock,
  FaAmbulance,
} from "react-icons/fa";
import { IoLogoWhatsapp } from "react-icons/io";
import {
  MdHealthAndSafety,
  MdMedicalServices,
  MdLocalHospital,
} from "react-icons/md";
import { GiMedicalPack, GiHealthNormal, GiMedicines } from "react-icons/gi";
import { Link, useNavigate } from "react-router-dom";

const Footer = () => {
  const navigate = useNavigate();

  const quickLinks = [
    { name: "Home", url: "/" },
    { name: "About Us", url: "/about-us" },
    { name: "Find a Doctor", url: "/find-doctors" },
    { name: "Contact Us", url: "/contact-us" },
    { name: "Blog", url: "/blogs" },
    { name: "Case Study", url: "/case-study" },
  ];

  const quickServices = [
    "Online Doctor Consultations",
    "In-Clinic Appointments",
    "Emergency Care",
    "Diagnostic Tests",
    "Health Checkup Packages",
    "Pharmacy Delivery",
    "Second Opinion Services",
    "Home Healthcare",
    "Mental Wellness Support",
    "Nutrition Counseling",
  ];

  const specialties = [
    "Cardiology",
    "Neurology",
    "Orthopedics",
    "Pediatrics",
    "Gynecology",
    "Dermatology",
    "Ophthalmology",
    "Dentistry",
    "Psychiatry",
    "Gastroenterology",
    "Pulmonology",
    "ENT Specialists",
    "Urology",
    "Endocrinology",
    "Rheumatology",
  ];

  const countries = [
    "India",
    "United States",
    "United Kingdom",
    "Canada",
    "Australia",
    "Germany",
    "France",
    "Italy",
    "Spain",
    "United Arab Emirates",
    "Saudi Arabia",
    "Singapore",
    "Malaysia",
    "South Africa",
    "Qatar",
    "Kuwait",
    "Switzerland",
    "Netherlands",
    "Sweden",
    "Ireland",
    "Japan",
    "South Korea",
    "Brazil",
    "Thailand",
    "China",
    "Russia",
    "Mexico",
    "Indonesia",
    "Philippines",
    "Vietnam",
    "New Zealand",
    "Norway",
    "Denmark",
    "Finland",
    "Poland",
    "Belgium",
    "Austria",
    "Turkey",
    "Egypt",
    "Israel",
    "Pakistan",
    "Bangladesh",
    "Sri Lanka",
    "Nepal",
    "Bhutan",
    "Maldives",
    "Myanmar",
    "Afghanistan",
    "Iran",
    "Iraq",
    "Oman",
    "Bahrain",
    "Jordan",
    "Lebanon",
    "Greece",
    "Portugal",
    "Hungary",
    "Czech Republic",
    "Romania",
    "Bulgaria",
    "Ukraine",
    "Argentina",
    "Chile",
    "Colombia",
    "Peru",
    "Venezuela",
    "Morocco",
    "Nigeria",
    "Kenya",
    "Ethiopia",
    "Ghana",
    "Tanzania",
    "Uganda",
    "Zimbabwe",
    "Zambia",
    "Algeria",
    "Tunisia",
    "Libya",
    "Sudan",
    "Iceland",
    "Luxembourg",
    "Slovakia",
    "Slovenia",
    "Croatia",
    "Serbia",
    "Lithuania",
    "Latvia",
    "Estonia",
    "Malta",
    "Cyprus",
    "Paraguay",
    "Uruguay",
    "Bolivia",
    "Costa Rica",
    "Panama",
    "Cuba",
    "Dominican Republic",
    "Jamaica",
    "Cambodia",
    "Laos",
    "Brunei",
    "Mongolia",
    "Kazakhstan",
    "Uzbekistan",
    "Turkmenistan",
    "Armenia",
    "Georgia",
    "Azerbaijan",
  ];

  const cities = [
    "Mumbai",
    "Delhi",
    "Bengaluru",
    "Hyderabad",
    "Chennai",
    "Kolkata",
    "Pune",
    "Ahmedabad",
    "Jaipur",
    "Lucknow",
    "Noida",
    "Gurgaon",
    "Chandigarh",
    "Indore",
    "Bhopal",
    "Nagpur",
    "Patna",
    "Ranchi",
    "Bhubaneswar",
    "Guwahati",
    "Dehradun",
    "Shimla",
    "Jammu",
    "Srinagar",

    "Amritsar",
    "Ludhiana",
    "Jalandhar",
    "Agra",
    "Kanpur",
    "Varanasi",
    "Prayagraj",
    "Meerut",
    "Ghaziabad",
    "Aligarh",
    "Bareilly",
    "Moradabad",
    "Gorakhpur",
    "Mathura",
    "Jhansi",
    "Raipur",
    "Bilaspur",
    "Durg",
    "Surat",
    "Vadodara",
    "Rajkot",
    "Jamnagar",
    "Bhavnagar",
    "Gandhinagar",
    "Nashik",
    "Thane",
    "Aurangabad",
    "Solapur",
    "Kolhapur",
    "Navi Mumbai",
    "Mysuru",
    "Mangaluru",
    "Hubli",
    "Belagavi",
    "Kalaburagi",
    "Kochi",
    "Thiruvananthapuram",
    "Kozhikode",
    "Thrissur",
    "Kannur",
    "Coimbatore",
    "Madurai",
    "Salem",
    "Tiruchirappalli",
    "Vellore",
    "Warangal",
    "Nizamabad",
    "Karimnagar",
    "Vijayawada",
    "Visakhapatnam",
    "Guntur",
    "Nellore",
    "Tirupati",
    "Kakinada",
    "Rajahmundry",
    "Cuttack",
    "Rourkela",
    "Sambalpur",
    "Jamshedpur",
    "Dhanbad",
    "Hazaribagh",
    "Gwalior",
    "Jabalpur",
    "Ujjain",
    "Satna",
    "Rewa",
    "Kota",
    "Jodhpur",
    "Udaipur",
    "Ajmer",
    "Bikaner",
    "Alwar",
    "Panipat",
    "Ambala",
    "Hisar",
    "Rohtak",
    "Silchar",
    "Dibrugarh",
    "Shillong",
    "Aizawl",
    "Imphal",
    "Agartala",
    "Gangtok",
    "Itanagar",
    "Tawang",
    "Haridwar",
    "Rishikesh",
    "Haldwani",
    "Darjeeling",
    "Siliguri",
    "Durgapur",
    "Asansol",
    "Jammu",
    "Anantnag",
    "Baramulla",
    "Puducherry",
    "Port Blair",
  ];

  return (
    <footer className="relative font-sans bg-gradient-to-b from-slate-50 to-white">
      {/* Top Gradient Strip */}
      <div className="bg-teal-700 py-4 mt-8 px-6 md:px-12">
        <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-6">
            <span className="text-white font-semibold text-lg">
              Connect with us:
            </span>
            <div className="flex items-center gap-4">
              <a
                href="#"
                className="bg-white/20 p-2 rounded-full hover:bg-white/30 transition"
              >
                <FaFacebookF className="text-white text-lg" />
              </a>
              <a
                href="#"
                className="bg-white/20 p-2 rounded-full hover:bg-white/30 transition"
              >
                <FaInstagram className="text-white text-lg" />
              </a>
              <a
                href="#"
                className="bg-white/20 p-2 rounded-full hover:bg-white/30 transition"
              >
                <FaYoutube className="text-white text-lg" />
              </a>
              <a
                href="#"
                className="bg-white/20 p-2 rounded-full hover:bg-white/30 transition"
              >
                <IoLogoWhatsapp className="text-white text-lg" />
              </a>
            </div>
          </div>
          <div className="flex items-center gap-4">
            <span className="text-white/90 text-sm">Download App:</span>
            <img
              src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg"
              alt="Google Play"
              className="h-8"
            />
            <img
              src="https://upload.wikimedia.org/wikipedia/commons/3/3c/Download_on_the_App_Store_Badge.svg"
              alt="App Store"
              className="h-8"
            />
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16">
        {/* Company Intro - Modern Card */}
        <div className="relative bg-white rounded-3xl shadow-xl overflow-hidden mb-16">
          <div className="absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-teal-700 via-cyan-500 to-orange-500"></div>
          <div className="p-8 md:p-12">
            <div className="flex flex-col lg:flex-row items-start gap-8">
              <div className="lg:w-2/3">
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-12 h-12 bg-teal-100 rounded-2xl flex items-center justify-center">
                    <MdHealthAndSafety className="text-teal-700 text-3xl" />
                  </div>
                  <h1 className="text-3xl md:text-4xl font-bold">
                    <span className="bg-teal-700 bg-clip-text text-transparent">
                      Digi Health
                    </span>
                  </h1>
                </div>
                <p className="text-gray-600 text-lg leading-relaxed mb-6">
                  India's most trusted digital healthcare platform, connecting
                  you with top allopathy doctors and medical specialists. We're
                  revolutionizing healthcare delivery through cutting-edge
                  technology and compassionate care.
                </p>
                <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                  {[
                    { number: "500+", label: "Expert Doctors" },
                    { number: "50L+", label: "Happy Patients" },
                    { number: "24/7", label: "Emergency Support" },
                    { number: "100%", label: "Safe & Secure" },
                  ].map((stat, idx) => (
                    <div
                      key={idx}
                      className="bg-gray-50 rounded-xl p-4 text-center"
                    >
                      <div className="text-2xl font-bold text-teal-600">
                        {stat.number}
                      </div>
                      <div className="text-sm text-gray-600">{stat.label}</div>
                    </div>
                  ))}
                </div>
              </div>
              <div className="lg:w-1/3 bg-gradient-to-br from-teal-50 to-orange-50 rounded-2xl p-6">
                <h3 className="font-semibold text-gray-800 mb-3 flex items-center gap-2">
                  <FaRegClock className="text-teal-700" />
                  Emergency Services
                </h3>
                <p className="text-3xl font-bold text-teal-700 mb-2">
                  24x7 Available
                </p>
                <p className="text-gray-600 text-sm mb-4">
                  Immediate medical assistance at your fingertips
                </p>
                <Link to={"/emergency"}>
                  <button className="w-full bg-teal-700 text-white py-3 rounded-xl font-semibold hover:bg-teal-800 transition flex items-center justify-center gap-2">
                    <FaAmbulance />
                    Request Emergency
                  </button>
                </Link>
              </div>
            </div>
          </div>
        </div>

        {/* Quick Services Grid */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4 mb-16">
          {[
            {
              icon: <FaStethoscope />,
              label: "Online Consultation",
              color: "blue",
            },
            { icon: <MdLocalHospital />, label: "Clinic Visit", color: "cyan" },
            {
              icon: <GiMedicalPack />,
              label: "Medicine Delivery",
              color: "teal",
            },
            { icon: <FaHeartbeat />, label: "Health Checkup", color: "green" },
            { icon: <FaAmbulance />, label: "Emergency Care", color: "red" },
          ].map((item, idx) => (
            <div
              key={idx}
              className="bg-white rounded-xl p-4 shadow-md hover:shadow-lg transition cursor-pointer group"
            >
              <div
                className={`w-12 h-12 bg-${item.color}-100 rounded-lg flex items-center justify-center mb-3 group-hover:scale-110 transition`}
              >
                <div className={`text-${item.color}-600 text-2xl`}>
                  {item.icon}
                </div>
              </div>
              <p className="font-medium text-gray-800 text-sm">{item.label}</p>
            </div>
          ))}
        </div>

        {/* Main Links Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 mb-16">
          {/* Quick Links */}
          <div className="lg:col-span-4">
            <h3 className="text-lg font-bold text-gray-800 mb-4">
              Quick Links
            </h3>
            <ul className="space-y-3">
              {quickLinks.map((link, idx) => (
                <li key={idx}>
                  <a
                    href={link.url}
                    className="text-gray-600 hover:text-blue-600 transition flex items-center gap-2"
                  >
                    <span className="w-1 h-1 bg-blue-400 rounded-full"></span>
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Specialties */}
          {/* <div className="lg:col-span-4">
            <h3 className="text-lg font-bold text-gray-800 mb-4">
              Medical Specialties
            </h3>
            <div className="grid grid-cols-2 gap-x-4 gap-y-3">
              {specialties.map((specialty, idx) => (
                <a
                  key={idx}
                  href="#"
                  className="text-gray-600 hover:text-blue-600 transition flex items-center gap-2 text-sm"
                >
                  <FaArrowRight className="text-blue-400 text-xs" />
                  {specialty}
                </a>
              ))}
            </div>
          </div> */}

          {/* Services */}
          <div className="lg:col-span-4">
            <h3 className="text-lg font-bold text-gray-800 mb-4">
              Our Services
            </h3>
            <ul className="space-y-3">
              {quickServices.map((service, idx) => (
                <li key={idx}>
                  <a
                    // href="#"
                    className="text-gray-600 hover:text-blue-600 transition flex items-center gap-2"
                  >
                    <MdMedicalServices className="text-blue-400" />
                    {service}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div className="lg:col-span-4">
            <h3 className="text-lg font-bold text-gray-800 mb-4">
              Get in Touch
            </h3>
            <div className="space-y-4">
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 bg-blue-100 rounded-lg flex items-center justify-center flex-shrink-0">
                  <FaPhoneAlt className="text-blue-600" />
                </div>
                <div>
                  <p className="text-sm text-gray-500">24/7 Helpline</p>
                  <p className="font-semibold text-gray-800">+91 9236398123</p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 bg-cyan-100 rounded-lg flex items-center justify-center flex-shrink-0">
                  <FaEnvelope className="text-cyan-600" />
                </div>
                <div>
                  <p className="text-sm text-gray-500">Email Support</p>
                  <p className="font-semibold text-gray-800">
                    connect.digihealth@gmail.com
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 bg-teal-100 rounded-lg flex items-center justify-center flex-shrink-0">
                  <FaMapMarkerAlt className="text-teal-600" />
                </div>
                <div>
                  <p className="text-sm text-gray-500">Corporate Office</p>
                  <p className="font-semibold text-gray-800 text-sm">
                    Digiquest Consultancy Servvices Pvt. Ltd.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Countries & Cities */}
        <div className="space-y-6 mb-16">
          <div className="bg-gradient-to-r from-blue-50 to-cyan-50 rounded-2xl p-6">
            <h3 className="font-bold text-gray-800 mb-4 flex items-center gap-2">
              {/* <FaGlobe className="text-blue-600" /> */}
              Countries We Serve
            </h3>
            <div className="flex flex-wrap gap-2">
              {countries.map((country, idx) => (
                <button
                  key={idx}
                  onClick={() => navigate(`/${country}`)}
                  className="px-4 py-2 bg-white rounded-full text-sm border border-gray-200 hover:border-blue-400 hover:text-blue-600 transition shadow-sm"
                >
                  {country}
                </button>
              ))}
            </div>
          </div>

          <div className="bg-gradient-to-r from-cyan-50 to-teal-50 rounded-2xl p-6">
            <h3 className="font-bold text-gray-800 mb-4">
              Cities We Serve in India
            </h3>
            <div className="flex flex-wrap gap-2">
              {cities.map((city, idx) => (
                <button
                  key={idx}
                  className="px-3 py-1.5 bg-white rounded-lg text-sm border border-gray-200 hover:border-cyan-400 hover:text-cyan-600 transition"
                >
                  {city}
                </button>
              ))}
            </div>
          </div>
        </div>

        {/* Trust Badges */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-12">
          {[
            { icon: <FaShieldAlt />, text: "ISO 27001 Certified" },
            { icon: <GiHealthNormal />, text: "HIPAA Compliant" },
            { icon: <FaUserMd />, text: "Verified Doctors" },
            { icon: <GiMedicines />, text: "Safe Medicine Delivery" },
          ].map((badge, idx) => (
            <div
              key={idx}
              className="flex items-center gap-3 bg-gray-50 p-3 rounded-xl"
            >
              <div className="text-blue-600 text-xl">{badge.icon}</div>
              <span className="text-sm font-medium text-gray-700">
                {badge.text}
              </span>
            </div>
          ))}
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-200 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-sm text-gray-500">
              © 2008-{new Date().getFullYear()} DIGIQUEST CONSULTANCY SERVICES
              PRIVATE LIMITED. All Rights Reserved.
            </p>
            <div className="flex gap-6 text-sm">
              <a
                href="/privacy-policy"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-500 hover:text-blue-600 transition"
              >
                Privacy Policy
              </a>
              <a
                href="/terms-conditions"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-500 hover:text-blue-600 transition"
              >
                Terms of Use
              </a>
              {/* <a
                href="/cookie-policy"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-500 hover:text-blue-600 transition"
              >
                Cookie Policy
              </a> */}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
